var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex"},[(_vm.withEnds)?_c('div',{staticClass:"h-dot w-dot",style:({
      backgroundImage: 'url(' + require('@/assets/dotted-left.png') + ')'
    })}):_vm._e(),_c('div',{staticClass:"flex-1 h-dot bg-white",style:({
      backgroundImage: 'url(' + require('@/assets/dotted-repeat.png') + ')'
    })}),(_vm.withEnds)?_c('div',{staticClass:"h-dot w-dot",style:({
      backgroundImage: 'url(' + require('@/assets/dotted-right.png') + ')'
    })}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }